/**
 * siteConfig.ts — Editable, build-time only constants.
 * Phase 4 of THE_LAST_MILE: makes capacity badge and working-hours strings
 * trivially updateable without touching component code. Zero-JS preserved
 * (these values are inlined at build time by Vite/SSR).
 */
export const siteConfig = {
  monthlyCapacity: 8,
  remainingSlots: 4,
  workingDays: { start: "الأحد", end: "الخميس" },
  workingHours: { start: "٩ص", end: "٦م" },
  responseTime: "٣٠ دقيقة",
  email: "Care@itQan.Agency",
  phone: "+966 56 820 1181",
  phoneRaw: "+966568201181",
  whatsappNumber: "966568201181",
} as const;
